export const InteractiveCursorIcon: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    fill="currentColor"
    width="30rem"
    height="30rem"
    viewBox="0 0 32 32"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20,8h-2c0-2.76-2.24-5-5-5s-5,2.24-5,5h-2c0-3.87,3.13-7,7-7s7,3.13,7,7Z" />
    <path d="M25,15c-.52,0-1.02.14-1.47.4-.55-.87-1.5-1.4-2.53-1.4-.52,0-1.02.14-1.47.4-.75-1.18-2.21-1.68-3.53-1.22v-5.18h0c0-1.66-1.34-3-3-3s-3,1.34-3,3v11.1l-2.23-1.52h0c-.51-.38-1.13-.58-1.77-.58-1.66,0-3,1.34-3.01,2.99,0,.8.32,1.57.89,2.14l8,7.3c1.13,1.01,2.6,1.57,4.12,1.57h5c3.87,0,7-3.13,7-7v-6c0-1.66-1.34-3-3-3Z" />
    <path
      fill="white"
      d="M26,24c0,2.76-2.24,5-5,5h-5c-1.01.01-1.99-.34-2.76-1l-7.95-7.3c-.18-.19-.29-.44-.29-.7,0-.55.45-1,1-1,.22,0,.43.07.6.2l5.4,3.7V8c0-.55.45-1,1-1s1,.45,1,1h0v11h2v-3c0-.55.45-1,1-1s1,.45,1,1v3h2v-2c0-.55.45-1,1-1s1,.45,1,1v2h2v-1c0-.55.45-1,1-1s1,.45,1,1v6Z"
    />
  </svg>
);
